/**
 * Created by shmbgd on 29.11.22.
 */
import * as React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { observer, Provider } from 'mobx-react';
import './Store/Firebase/firebase';
import { Root } from './Root';
import { rootStore, RootStoreContext } from './Store/useRootStore';
import { PointsCollectedModal } from './Components/PointsCollectedModal';
import { Toast } from './Components/Toast';
import { Auth0Provider } from '@auth0/auth0-react';
import { LanguageProvider } from './Contexts/LanguageContext';
import { useNotificationRegistration } from './Hooks/useNotificationRegistration';
import { ServiceLifecycleBoundary } from './Components/ServiceLifecycleBoundary';

export type AppProps = {};

const AppContent: React.FC = observer(() => {
  // Auto-register push notifications when user logs in
  useNotificationRegistration();

  return (
    <>
      <PointsCollectedModal />
      <Toast />
      <Root />
    </>
  );
});

export const App: React.FC<AppProps> = observer(() => {
  const onRedirectCallback = (appState?: { returnTo?: string }) => {
    const returnTo = appState?.returnTo || '/home';
    // Use window.location.replace to actually navigate, not just change URL
    window.location.replace(returnTo);
  };

  return (
    <Auth0Provider
      domain="auth.kinastic.com"
      clientId="Tsx3nPnr13gNWvA2JyRXRTwznxIkAqzk"
      useRefreshTokens={true}
      useRefreshTokensFallback={true}
      authorizationParams={{ audience: 'https://api.kinastic.com' }}
      onRedirectCallback={onRedirectCallback}
    >
      <LanguageProvider>
        <Provider rootStore={rootStore}>
          <RootStoreContext.Provider value={rootStore}>
            <BrowserRouter>
              <ServiceLifecycleBoundary>
                <AppContent />
              </ServiceLifecycleBoundary>
            </BrowserRouter>
          </RootStoreContext.Provider>
        </Provider>
      </LanguageProvider>
    </Auth0Provider>
  );
});
